<div class="section">
  @if (isLoading) {
    <div class="loading-wrap">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (condominiumId) {
    <app-subscription-plan-selector
      [condominiumId]="condominiumId"
      [currentSubscriptionPlan]="condominium?.subscriptionType"
      (planSelected)="onPlanSelected($event)"
      (subscriptionCancelled)="onSubscriptionCancelled()">
    </app-subscription-plan-selector>
    <div class="change-plan-actions">
      <button
        mat-raised-button
        color="primary"
        [disabled]="!selectedPlan || isChangingPlan"
        (click)="openChangePlanConfirmation()">
        Alterar plano
      </button>
    </div>
  }
</div>
